import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

// import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
// import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
// import TimePicker from '@material-ui/lab/TimePicker';

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { AssignmentButtonWrapper, TableWrapper } from '../../../styles/assignment/assignment';
import { Link } from 'react-router-dom';
import { Table } from '../../../components/table/table';
import { TableData } from '../../../services/tableData';
import { CustomModal } from '../../../components/modal'
// import { RowDots } from "../../../components/table/row-menu";

const schema = yup.object().shape({
    title: yup.string().required("result title is a required field"),
    defaultScore: yup.string().required("default score is a required field"),
    maxScore: yup.string().required("max score is a required field"),
});


const ResultsView = () => {

    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
        },
        {
            name: "Class",
            selector: (row) => row.class,
        },
        {
            name: "Date Submitted",
            selector: (row) => row.dateSubmitted,
        },
        {
            name: "Score",
            selector: (row) => row.score,
        },
        {
            name: "Date Scored",
            selector: (row) => row.dateScored,
        },
        {
            name: "Grade",
            selector: (row) => row.grade,
        },
        // {
        //     name: "",
        //     selector: (row) => row.address,
        //     width: "50px",
        //     cell: () => {
        //         return (
        //             <RowDots
        //                 options={["Edit school", "Feature"]}
        //             // optionsFns={[() => router.push(`edit`)]}
        //             />
        //         );
        //     },
        // },
    ];

    const [showModal, setShowModal] = useState(false);

    const {
        handleSubmit,
        register,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
        setShowModal(false)
    }

    return (
        <>
            <CustomModal title="Add Result Modal" onClose={() => setShowModal(false)} showModal={showModal}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <Input
                            id="resultTitle"
                            type="text"
                            placeholder="Result Title"
                            {...register("title")}
                            error={errors.title?.message}
                            fullWidth
                        />

                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            id="defaultScore"
                            type="text"
                            placeholder="Default Score"
                            {...register("defaultScore")}
                            error={errors.defaultScore?.message}
                            fullWidth
                        />

                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            id="resultMaxScore"
                            type="text"
                            placeholder="Max Score"
                            {...register("maxScore")}
                            error={errors.maxScore?.message}
                            fullWidth
                        />
                    </InputWrapper>
                    <Button
                        type="submit"
                        style={{ marginLeft: 'auto', marginTop: '6rem' }}
                        responsive
                    >
                        ADD
                    </Button>
                </form>
            </CustomModal>

            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <MainContent>
                            <Heading>
                                Results
                            </Heading>
                            <Breadcrumb
                                crumbs={['Results', "mathematics"]}
                            />
                            <div style={{ marginTop: '8.7rem' }}>
                                <AssignmentButtonWrapper>

                                    <Button size='small'>DOWNLOAD</Button>

                                    <Button onClick={() => setShowModal(true)} size='small' variant="secondary">aDD RESET COLUMN</Button>
                                    <Link to='/teacher/results/upload'>
                                        <Button size='small' variant="secondary">upLOAD RESULT</Button>
                                    </Link>
                                    <Button size='small' variant="secondary">save</Button>
                                    <Button size='small' variant="secondary">PROCESS rEsult</Button>
                                </AssignmentButtonWrapper>
                                <TableWrapper>
                                    <Table
                                        columns={columns}
                                        data={TableData || []}
                                    />
                                </TableWrapper>
                            </div>
                        </MainContent>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper >
        </>
    )
}

export default ResultsView
